import type { ItemDef } from '@/core/content/schemas/items';

/** UI colour for an item chip; mirrors the greybox tint in game/views/placeholders (set first, then theme). */
export function swatchFor(def: ItemDef): string {
  switch (def.setId) {
    case 'set_pine':
      return 'var(--c-wood)';
    case 'set_strawberry':
      return 'var(--c-blush)';
    case 'set_office':
      return 'var(--c-lavender)';
    case 'set_garden':
      return 'var(--c-mint)';
    default:
      break;
  }
  if (def.themeTags.includes('garden') || def.themeTags.includes('healthy')) return 'var(--c-mint)';
  if (def.themeTags.includes('pet')) return 'var(--c-butter)';
  if (def.themeTags.includes('cute') || def.themeTags.includes('sweet')) return 'var(--c-blush)';
  if (def.themeTags.includes('office')) return 'var(--c-lavender)';
  if (def.kind === 'fixture') return 'var(--c-sky)';
  return 'var(--c-cream-deep)';
}
